import {Box, Center, Paper, Popover, Text, ThemeIcon} from "@mantine/core";
import {Title} from "@mantine/core";

import {useTranslation} from "react-i18next";

export function DenyPopover({
    icon,
    title,
    description,
}: {
    icon: React.ReactNode;
    title: string;
    description: string;
}) {
    const {t} = useTranslation();
    const ReactIcon = icon;
    return (
        <Box
            pos={"absolute"}
            style={{
                zIndex: 10000,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(5px)",
                width: "100vw",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Paper
                withBorder
                shadow="md"
                px={"xl"}
                py={60}
                radius="md"
                style={{maxWidth: "500px"}}
            >
                <Center>
                    <ThemeIcon size="xl" radius="xl" color="red">
                        {ReactIcon}
                    </ThemeIcon>
                </Center>
                <Title ta="center" mt="md" mb="xs">
                    {t("forbidden.title")}
                </Title>
                <Text color="dimmed" size="lg" ta="center">
                    {t("forbidden.description")}
                </Text>
            </Paper>
        </Box>
    );
}
